import React, { useState } from "react";
import logo from "../assets/img/logo.svg";
import { Link } from "react-router-dom";
import CheckboxInput from "../components/CheckboxInput";
import { toast } from "sonner";
import { getUserInfo } from "../api/auth";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { profileValidate } from "../utils/Validations";
import { PATH_ROOT } from "../routes/paths";

const ProfileSetup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    id: "",
    popular_track_stream: "",
    songs_featured: "",
    monthly_listeners: "",
    perform_for_international_audience: "",
    published_under_bmi: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleRadioChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const errors = profileValidate(formData);
    setErrors(errors);
    if (Object.keys(errors).length !== 0) {
      setIsLoading(false)
    }
    if (Object.keys(errors).length === 0) {
      try {
        const customerIdFromLocalStorage = localStorage.getItem("customerId");
        if (customerIdFromLocalStorage) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            id: customerIdFromLocalStorage,
          }));
        }
        const response = await getUserInfo();
        if (response) {
          toast.success("Profile setup completed successfully!");
          navigate(PATH_ROOT.main.vault)
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        toast.error("Failed to complete profile setup. Please try again.");
      }
    }
  };

  return (
    <main className="equaliq">
      <div className="login-page">
        <header>
          <div className="box">
            <div className="header-content">
              <Link to="/">
                <img src={logo} alt="Logo" />
              </Link>
            </div>
          </div>
        </header>
        <section className="login-section">
          <div className="box">
            <div className="login-content signup-content">
              <div className="login-left">
                <div className="singer-info">
                  <h4>
                    Profile Setup <span>Create Account</span>
                  </h4>
                </div>
              </div>
              <div className="login-right">
                <form className="form-detail" onSubmit={handleSubmit}>
                  <div className="form-input-label">
                    <h5>How many streams has your most popular track received?</h5>
                    <div className="form-label">
                      <input
                        type="text"
                        name="popular_track_stream"
                        placeholder="Enter number of streams"
                        value={formData.popular_track_stream}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.popular_track_stream && <span className="error">{errors.popular_track_stream}</span>}
                  </div>
                  <div className="form-input-label">
                    <h5>Have your songs been featured in films, TV, or games?</h5>
                    <div className="radio-div">
                      <CheckboxInput
                        typename="radio"
                        label="Yes"
                        id="featuredYes"
                        name="songs_featured"
                        checked={formData.songs_featured === "Yes"}
                        onChange={() => handleRadioChange("songs_featured", "Yes")}
                      />
                      <CheckboxInput
                        typename="radio"
                        label="No"
                        id="featuredNo"
                        name="songs_featured"
                        checked={formData.songs_featured === "No"}
                        onChange={() => handleRadioChange("songs_featured", "No")}
                      />
                    </div>
                    {errors.songs_featured && <span className="error">{errors.songs_featured}</span>}
                  </div>
                  <div className="form-input-label">
                    <h5>How many monthly listeners do you have on a top music platform?</h5>
                    <div className="form-label">
                      <input
                        type="text"
                        name="monthly_listeners"
                        placeholder="Enter number of monthly listeners"
                        value={formData.monthly_listeners}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.monthly_listeners && <span className="error">{errors.monthly_listeners}</span>}
                  </div>
                  <div className="form-input-label">
                    <h5>Has your music been performed for international audiences?</h5>
                    <div className="radio-div">
                      <CheckboxInput
                        typename="radio"
                        label="Yes"
                        id="performedInternationallyYes"
                        name="perform_for_international_audience"
                        checked={formData.perform_for_international_audience === "Yes"}
                        onChange={() => handleRadioChange("perform_for_international_audience", "Yes")}
                      />
                      <CheckboxInput
                        typename="radio"
                        label="No"
                        id="performedInternationallyNo"
                        name="perform_for_international_audience"
                        checked={formData.perform_for_international_audience === "No"}
                        onChange={() => handleRadioChange("perform_for_international_audience", "No")}
                      />
                    </div>
                    {errors.perform_for_international_audience && <span className="error">{errors.perform_for_international_audience}</span>}
                  </div>
                  <div className="form-input-label">
                    <h5>Are you published under BMI, SESAC, or ASCAP?</h5>
                    <div className="radio-div">
                      <CheckboxInput
                        typename="radio"
                        label="Yes"
                        id="publishedYes"
                        name="published_under_bmi"
                        checked={formData.published_under_bmi === "Yes"}
                        onChange={() => handleRadioChange("published_under_bmi", "Yes")}
                      />
                      <CheckboxInput
                        typename="radio"
                        label="No"
                        id="publishedNo"
                        name="published_under_bmi"
                        checked={formData.published_under_bmi === "No"}
                        onChange={() => handleRadioChange("published_under_bmi", "No")}
                      />
                    </div>
                    {errors.published_under_bmi && <span className="error">{errors.published_under_bmi}</span>}
                  </div>
                  <button type="submit" disabled={isLoading}> {isLoading ? <Spinner variant="light" /> : "Finish Setup"} </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ProfileSetup;
